// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable no-unused-vars */
import iframeResizer from 'iframe-resizer'
import Vue from 'vue'
import App from './app'
import { i18n } from './languages/language'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Rlil from '@/components/rl-il'
import Pim from '@/components/pim'
import { ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

// Register it globally
// main.js or any entry file.
Vue.component('ValidationProvider', ValidationProvider)

// Override the default message.
extend('required', {
  ...required,
  message: 'This field is required'
})

library.add(faPhone)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('rl-il', Rlil)
Vue.component('pim', Pim)

Vue.config.productionTip = false

Vue.use(VueGoodTablePlugin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  components: { App },
  template: '<App/>'
})
